import { envConstants } from "./env-constant";

export const defaultLocation = {
  ZIP_CODE: "75001",
  COUNTY_DMA: "48113",
  FIPS_CODE: "08061"
}

export const POPULATE_CACHE_INETERVAL_MS: number =
  parseFloat(envConstants.TG_CACHE_INT || "25") * 1000 * 60;

export const ST = `\u272D`;

export const APP_NAMESPACE = `ufAppShell`;
export const CMS_USERNAME_MODEL = `$UserName`;
export const ORC_PATH = `/msapi/idp-content-orchestration/v1`;
export const ROOT_TOKEN = `%{ROOT}`;
export const SEARCH_API_URL = `https://services.att.com/search/v2/sitesearchapi/suggestions?app-id=sales&customer=consumer&q=`;
export const APPLICATION_NAME = `UF`;
export const PAGE_FUNCTION = `Other`;
export const LINE_OF_BUSINESS = `VIDEO`;
export const OWNERSHIP = `VIDEO`;
export const CONTENT_PAGE_SECTION_ID = `Personalized Page`;
export const CONTENT_SYSTEM = `AEM`;
export const SLOT_FRIENDLY_NAME = `ABTestSplit`;
export const SITE_SECTION = `myatt Sales`;
export const FLOW_CODE = `Prospect`;
export const LEGAL_MODAL_URL = "/modal-legal";
export const TIME_OUT_URL = "/timeout=true";

